import { BuilderSteps } from '@enums'

export const getRecentBuilderStep = (step1, step2) => {
  const builderSteps = Object.values(BuilderSteps)
  const step1Index = builderSteps.findIndex(step => step === step1)
  const step2Index = builderSteps.findIndex(step => step === step2)
  return (step1Index > step2Index ? step1 : step2) as BuilderSteps
}
